import { nonDisableAbleColumns } from '../../components/NRReactGrid/NRReactGrid.utils';
import { getSbomColumns } from './NRSBOMColumns.utils';

/** Columns that NRReactGrid never lists in its column chooser (the same list NRReactGrid uses). */
export const NON_CHOOSABLE_COLUMN_NAMES = nonDisableAbleColumns;

export const SBOM_GROUPED_TABLE_SETTINGS_KEY = 'SbomGroupedTableSettings';

/** localStorage key of the outer grouped table settings, one per grouping. */
export const getSbomGroupedSettingsKey = groupedBy => `${SBOM_GROUPED_TABLE_SETTINGS_KEY}_${groupedBy}`;

/**
 * localStorage key of the nested tables settings (hidden columns, filter row visibility, sort), one per grouping.
 * The outer table's chooser writes it and every nested table reads it, so build it only here.
 */
export const getSbomNestedSettingsKey = groupedBy => `${getSbomGroupedSettingsKey(groupedBy)}_inner`;

/** Nested table columns that must always stay visible (shown disabled in the chooser). */
export const NESTED_LOCKED_COLUMN_NAMES = ['name'];

/**
 * Columns rendered by the nested table of a grouped SBOM row: the regular SBOM columns (same rules as the flat table:
 * feature flags and organization enabled methods), minus the column used for grouping.
 */
export const getSbomNestedColumns = ({ groupedBy, ...sbomColumnsOptions }) =>
  getSbomColumns(sbomColumnsOptions).filter(column => !groupedBy || column.name !== groupedBy);

/** Nested columns the user can toggle from the column chooser. */
export const getSbomNestedChooserColumns = nestedColumns => nestedColumns.filter(column => !NON_CHOOSABLE_COLUMN_NAMES.includes(column.name));

/** Columns hidden until the user enables them (`hideColumn: true` on the column definition). */
export const getDefaultNestedHiddenColumnNames = (columns = []) => columns.filter(column => column.hideColumn).map(column => column.name);

/** Removes locked columns from a hidden list, so a locked column can never be restored as hidden. */
export const sanitizeHiddenColumnNames = (hiddenColumnNames, lockedColumnNames = []) =>
  Array.isArray(hiddenColumnNames) ? hiddenColumnNames.filter(name => !lockedColumnNames.includes(name)) : hiddenColumnNames;

/** Stored hidden columns when present, otherwise the column defaults. Locked columns are never hidden. */
export const resolveNestedHiddenColumnNames = ({ storedHiddenColumnNames, columns, lockedColumnNames = NESTED_LOCKED_COLUMN_NAMES }) =>
  sanitizeHiddenColumnNames(
    Array.isArray(storedHiddenColumnNames) ? storedHiddenColumnNames : getDefaultNestedHiddenColumnNames(columns),
    lockedColumnNames
  );
